import React from 'react';
import {connect} from 'react-redux'
// import LoadingGif2 from '../../../assets/images/loading.gif';
import LoadingGif from '../../../assets/images/loader_spin_greenBig.gif'; // loader_round_green.gif
 
class Loader extends React.Component {
	state = {}

  render() {
  	 const {loading} = this.props;
  	 if(!loading) return null;
    return (
        <div style={{ backgroundColor: 'rgba(97, 97, 97, 0.21)', height: '100%' , width: '100%', zIndex:9999, position: 'fixed', textAlign: 'center'}}>
        	<div style={{marginTop: '20%'}}><img style={{ height:'100px' }} src={LoadingGif} alt=""/>
        	<p style={{color:'rgb(0, 81, 162)', marginTop: '-20px', fontSize: '18px'}}>Loading...</p>
        	</div>
        	
        </div>
    )
  }
}

const mapStateToProps = state => ({loading:  state.loader.loading}) 

export default connect(mapStateToProps)(Loader);